import { h } from "preact";
import { useLocationFormStorage } from "./locationFormContext";

export function SubmitButton({ onSubmit }) {
  const { isValid } = useLocationFormStorage();

  return (
    <div className="col-span-1 md:col-span-1 flex items-start">
      <button
        type="button"
        class="btn btn--primary w-full h-full"
        disabled={!isValid}
        onClick={onSubmit}
      >
        {global.Translator.trans("locationform.searchbutton", {}, "js")}
      </button>
    </div>
  );
}
